import { Button, Flex, Text, UseToastOptions } from '@chakra-ui/react';
import { ReactComponent as AlertStatusIcon } from 'assets/icons/a11ymenu_alert.svg';
import { ReactComponent as OkStatusIcon } from 'assets/icons/a11ymenu_status_ok.svg';
import { ReactComponent as InfoStatusIcon } from 'assets/icons/filled_info.svg';

export interface ToastOptionProps extends UseToastOptions {
  buttonTitle?: string;
  handleClick?: () => void;
}

export const ToastContent = ({
  status = 'success',
  title,
  description,
  buttonTitle,
  handleClick,
}: ToastOptionProps) => {
  let color = 'green.500';
  let icon = <OkStatusIcon />;
  switch (status) {
    case 'info':
      icon = <InfoStatusIcon />;
      color = 'blue.500';
      break;
    case 'error':
      icon = <AlertStatusIcon color='var(--vg-colors-red-500)' />;
      color = 'red.500';
      break;
  }

  return (
    <Flex
      color={'white'}
      px={4}
      py={2}
      bg={'font.500'}
      alignItems={'center'}
      justifyContent={'space-between'}
      borderRadius={'5px'}
      borderBottom={'5px solid'}
      borderBottomColor={color}
      aria-live={'polite'}
      data-testid={`toast-content-${status}`}
    >
      <Flex gap={2} alignItems={'center'}>
        {icon}
        <Flex direction={'column'}>
          <Text fontWeight={500} fontSize={'0.875rem'}>
            {title}
          </Text>
          <Text fontSize={'0.875rem'}>{description}</Text>
        </Flex>
      </Flex>
      {handleClick ? (
        <Button size={'sm'} variant={'ghost'} fontWeight={500} onClick={handleClick}>
          {buttonTitle}
        </Button>
      ) : null}
    </Flex>
  );
};
